import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import { ThemeProvider } from 'react-jss';
import * as Sentry from '@sentry/react';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import 'antd/dist/antd.css';
import FallbackComponent from './components/common/FallbackComponent';
import { SENTRY_DSN } from './global';
import { getRouterBasename } from './lib/helper';
import './v2themes/styles.scss';
import 'react-input-range/lib/css/index.css';

Sentry.init({ dsn: SENTRY_DSN });

// Create the main app component with error boundary
const MainApp = () => (
  <ThemeProvider theme={{}}>
    <BrowserRouter basename={getRouterBasename()}>
      <App />
    </BrowserRouter>
  </ThemeProvider>
);

// Wrap with Sentry error boundary HOC
const AppWithErrorBoundary = Sentry.withErrorBoundary(MainApp, {
  fallback: ({ error, componentStack, resetError }) => (
    <FallbackComponent 
      error={error} 
      componentStack={componentStack} 
      resetError={resetError} 
    />
  ),
  showDialog: false,
});

ReactDOM.render(
  <React.StrictMode>
    <AppWithErrorBoundary />
  </React.StrictMode>,
  document.getElementById('root')
);

if (module.hot && process.env.NODE_ENV !== 'production') {
  module.hot.accept();
}